import angular from 'angular';
import copy from 'app/constants';
import {
  ssDialogService,
  loaderService,
  riskDataService,
  controlDataService,
  riskSharedModelService,
  controlSharedModelService
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-risk-dialog.controller';
import template from './edit-risk-dialog.html';
import assignControlDialog from '../dialog.assignControlDialog';
import nameMessagesTpl from './messages/risk.messages.html';
import riskAssetNameMessagesTpl from './messages/risk-asset.messages.html';
import riskTypeNameMessagesTpl from './messages/risk-type.messages.html';
import threatMessagesTpl from './messages/threat.multiplier.messages.html';
import validator, { name as validatorName } from './messages/risk-unique-name.validator.directive';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';
require('ng-file-upload/dist/ng-file-upload-shim');// Loads itself

export class dialogService {
  getOptions($event, {
    risk,
    riskTypes,
    assets,
    asset,
    preselectedAssetId,
    riskOnsets,
    riskForewarnings,
    riskDurations,
    riskDataConfidentialities,
    riskDataIntegrities,
    riskDataAvailabilities,
    riskDirections,
    riskTrendings,
    riskProbabilities,
    riskAssessmentFrequencies,
    riskClassifications,
    updateCallBack,
    riskType,
    isRiskMain,
  }) {
    return {
      controller,
      controllerAs: 'editRiskDialogVM',
      locals: {
        risk,
        riskTypes,
        assets,
        asset,
        preselectedAssetId,
        riskOnsets,
        riskForewarnings,
        riskDurations,
        riskDataConfidentialities,
        riskDataIntegrities,
        riskDataAvailabilities,
        riskDirections,
        riskTrendings,
        riskProbabilities,
        riskAssessmentFrequencies,
        riskClassifications,
        updateCallBack,
        riskType,
        isRiskMain,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.admin.controlAdministration.editRiskDialog', [
  ngFileUpload,
  ssDialogService,
  loaderService,
  riskDataService,
  copy,
  alerts,
  assignControlDialog,
  controlDataService,
  riskSharedModelService,
  controlSharedModelService,
])
  .service('editRiskDialog', dialogService)
  .directive(validatorName, validator)
  .run(($templateCache) => {
    $templateCache.put('risk.messages.html', nameMessagesTpl);
    $templateCache.put('risk.asset.messages.html', riskAssetNameMessagesTpl);
    $templateCache.put('risk.type.messages.html', riskTypeNameMessagesTpl);
    $templateCache.put('risk.threat.messages.html', threatMessagesTpl);
  })
  .name;

console.log('app.components.admin.controlAdministration.editRiskDialog created');
